<div
    class="tw-relative tw-bg-white tw-rounded-2xl tw-max-w-3xl tw-w-full tw-mx-auto tw-max-h-[90vh] tw-overflow-y-auto"
>
    <!-- Close button -->
    <div>
        <button
            [attr.ga-event-id]="ga_event[0].close.id"
            [attr.ga-event-category]="ga_event[0].category"
            ga-event-label="X Button Click"
            ga-track="track"
            (click)="closeDialog()"
            class="tw-absolute tw-right-4 tw-top-4 tw-text-black tw-text-2xl tw-z-10"
            aria-label="Close dialog"
        >
            ✕
        </button>
    </div>

    <div class="tw-p-6 tw-overflow-y-auto tw-my-5">
        <!-- Bank logo section -->
        <div
            class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center md:tw-items-start tw-gap-4 md:tw-gap-0 tw-mx-8 md:tw-mx-0 tw-mb-5"
        >
            <div
                class="tw-w-full md:tw-w-[250px] tw-h-[150px] tw-p-3 tw-border tw-border-gray-200 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-mb-6 tw-overflow-hidden"
            >
                <img
                    [src]="getImgUrl(data.bankDetails?.fiImage)"
                    alt="bank"
                    class="tw-max-h-44 tw-min-h-40 tw-object-contain tw-overflow-hidden"
                />
            </div>

            <button
                [attr.ga-event-id]="ga_event[0].calculateFinancing.id"
                [attr.ga-event-category]="ga_event[0].category"
                ga-event-label="Calculate My Financing Button Click"
                ga-track="track"
                (click)="calculateFinancing()"
                class="tw-bg-[#0f3b7e] tw-text-white tw-rounded-full tw-py-4 tw-px-4 tw-flex tw-items-center tw-gap-2 tw-w-full md:tw-w-auto tw-justify-center md:tw-justify-start"
            >
                <img
                    src="/assets/images/icons/Calculator-white.png"
                    class="tw-h-6 tw-w-auto"
                    alt="Calculate"
                />
                {{ "NEW_PRODUCTS.CALCULATE_MY_FINANCING" | translate }}
            </button>
        </div>

        <!-- Products list -->

        <div class="tw-space-y-8">
            <div *ngFor="let product of visibleProducts" class="tw-space-y-4">
                <div
                    class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-start tw-gap-2 md:tw-gap-0 tw-my-4"
                >
                    <p class="tw-text-lg tw-font-semibold">
                        {{ product.productName }}
                    </p>
                    <button
                        [attr.ga-event-id]="
                            product.prodCode + ga_event[0].checkEligibility.id
                        "
                        [attr.ga-event-category]="ga_event[0].category"
                        ga-event-label="Check Eligibility Button Click"
                        ga-track="track"
                        (click)="onClickEligibility(product.prodCode)"
                        class="tw-bg-[#ff8819] tw-text-white tw-rounded-full tw-hidden md:tw-block tw-w-[178px] tw-h-[44px] tw-font-bold tw-py-3 tw-px-6 tw-text-center"
                    >
                        {{ "COMMON.APPLY_NOW" | translate }}
                    </button>
                </div>

                <!-- Desktop Table (hidden on mobile) -->

                <table
                    class="tw-w-full tw-border-spacing-2 tw-border-separate tw-mb-6 md:tw-table tw-hidden"
                >
                    <caption class="tw-sr-only">
                        product info table
                    </caption>
                    <thead>
                        <tr>
                            <th
                                class="tw-bg-gray-100 tw-p-3 tw-text-left tw-w-[30%] tw-mx-2 tw-border-b-0"
                            >
                                <div class="tw-text-gray-600 tw-text-sm">
                                    {{ "COMMON.FINANCING" | translate }}
                                </div>
                            </th>
                            <th
                                class="tw-bg-gray-100 tw-p-3 tw-text-left tw-w-[25%] tw-mx-2 tw-border-b-0"
                            >
                                <div class="tw-text-gray-600 tw-text-sm">
                                    {{ "NEW_PRODUCTS.PROCESSING" | translate }}
                                </div>
                            </th>
                            <th
                                class="tw-bg-gray-100 tw-p-3 tw-text-left tw-w-[25%] tw-mx-2 tw-border-b-0"
                            >
                                <div class="tw-text-gray-600 tw-text-sm">
                                    {{ "NEW_PRODUCTS.TENURE" | translate }}
                                </div>
                            </th>
                            <th
                                class="tw-bg-gray-100 tw-p-3 tw-text-left tw-w-[20%] tw-mx-2 tw-border-b-0"
                            >
                                <div class="tw-text-gray-600 tw-text-sm">
                                    {{ "NEW_PRODUCTS.INTEREST" | translate }}
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="tw-p-3 tw-border-t tw-border-gray-200">
                                <div class="tw-font-bold tw-text-[14px]">
                                    <span
                                        >RM
                                        {{
                                            product.prodFinAmtMin | number
                                        }}</span
                                    >
                                    - <br />
                                    <span
                                        >RM
                                        {{
                                            product.prodFinAmtMax | number
                                        }}</span
                                    >
                                </div>
                                <div class="tw-text-xs tw-text-gray-500">
                                    {{ "NEW_PRODUCTS.STARTS_FROM" | translate }}
                                </div>
                            </td>
                            <td class="tw-p-3 tw-border-t tw-border-gray-200">
                                <div class="tw-font-bold tw-text-[14px]">
                                    {{ product.prodTat }}
                                    {{ "WORKING_DAYS" | translate }}
                                </div>
                            </td>
                            <td class="tw-p-3 tw-border-t tw-border-gray-200">
                                <div class="tw-font-bold tw-text-[14px]">
                                    {{ product.prodTenure }}
                                    <ng-container
                                        *ngIf="
                                            product.productValidation === 'null'
                                        "
                                        >{{ "YEARS" | translate }}</ng-container
                                    >
                                    <ng-container
                                        *ngIf="
                                            product.productValidation !== 'null'
                                        "
                                        >{{
                                            getUnitFromValidation(
                                                product.productValidation
                                            ) | translate
                                        }}</ng-container
                                    >
                                </div>
                            </td>
                            <td class="tw-p-3 tw-border-t tw-border-gray-200">
                                <div class="tw-font-bold tw-text-[14px]">
                                    {{ product.prodInterestRate }}%
                                    {{ "FROM_P_A" | translate }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- Mobile Table (visible only on mobile) -->
                <div class="md:tw-hidden tw-block tw-mb-6">
                    <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                        <!-- Row 1: Financing and Processing -->
                        <div>
                            <div class="tw-bg-gray-100 tw-p-3 tw-mx-0">
                                <div class="tw-text-gray-600 tw-text-sm">
                                    {{ "COMMON.FINANCING" | translate }}
                                </div>
                            </div>
                            <div class="tw-p-3 tw-border-t tw-border-gray-200">
                                <div class="tw-font-bold tw-text-[14px]">
                                    <span
                                        >RM
                                        {{
                                            product.prodFinAmtMin | number
                                        }}</span
                                    >
                                    - <br />
                                    <span
                                        >RM{{
                                            product.prodFinAmtMax | number
                                        }}</span
                                    >
                                </div>
                                <div class="tw-text-xs tw-text-gray-500">
                                    {{ "NEW_PRODUCTS.STARTS_FROM" | translate }}
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="tw-bg-gray-100 tw-p-3 tw-mx-0">
                                <div class="tw-text-gray-600 tw-text-sm">
                                    {{ "NEW_PRODUCTS.PROCESSING" | translate }}
                                </div>
                            </div>
                            <div class="tw-p-3 tw-border-t tw-border-gray-200">
                                <div class="tw-font-bold tw-text-[14px]">
                                    {{ product.prodTat }}
                                    {{ "WORKING_DAYS" | translate }}
                                </div>
                            </div>
                        </div>

                        <!-- Row 2: Tenure and Interest -->
                        <div>
                            <div class="tw-bg-gray-100 tw-p-3 tw-mx-0 tw-mt-2">
                                <div class="tw-text-gray-600 tw-text-sm">
                                    {{ "NEW_PRODUCTS.TENURE" | translate }}
                                </div>
                            </div>
                            <div class="tw-p-3 tw-border-t tw-border-gray-200">
                                <div class="tw-font-bold tw-text-[14px]">
                                    {{ product.prodTenure }}
                                    <ng-container
                                        *ngIf="
                                            product.productValidation === 'null'
                                        "
                                        >{{ "YEARS" | translate }}</ng-container
                                    >
                                    <ng-container
                                        *ngIf="
                                            product.productValidation !== 'null'
                                        "
                                        >{{
                                            getUnitFromValidation(
                                                product.productValidation
                                            ) | translate
                                        }}</ng-container
                                    >
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="tw-bg-gray-100 tw-p-3 tw-mx-0 tw-mt-2">
                                <div class="tw-text-gray-600 tw-text-sm">
                                    {{ "NEW_PRODUCTS.INTEREST" | translate }}
                                </div>
                            </div>
                            <div class="tw-p-3 tw-border-t tw-border-gray-200">
                                <div class="tw-font-bold tw-text-[14px]">
                                    {{ product.prodInterestRate }}%
                                    {{ "FROM_P_A" | translate }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <button
                        [attr.ga-event-id]="
                            product.prodCode + ga_event[0].checkEligibility.id
                        "
                        [attr.ga-event-category]="ga_event[0].category"
                        ga-event-label="Check Eligibility Button Click"
                        ga-track="track"
                        (click)="onClickEligibility(product.prodCode)"
                        class="tw-bg-[#ff8819] tw-text-white tw-rounded-full tw-block tw-w-[178px] tw-h-[44px] tw-font-bold tw-py-3 tw-px-6 tw-text-center tw-mx-auto tw-mt-3"
                    >
                        {{ "COMMON.APPLY_NOW" | translate }}
                    </button>
                </div>
                <hr />
            </div>
        </div>
        <!-- Show more button -->
        <div class="tw-flex tw-justify-center tw-mt-8" *ngIf="hasMoreProducts">
            <button
                [attr.ga-event-id]="ga_event[0].showMoreProducts.id"
                [attr.ga-event-category]="ga_event[0].category"
                ga-event-label="Show More Products Button Click"
                ga-track="track"
                (click)="toggleShowMore()"
                class="tw-border tw-border-[#003A70] tw-rounded-full tw-py-4 tw-px-6 tw-flex tw-items-center tw-gap-2 tw-text-[#003A70] tw-font-semibold"
            >
                {{ "NEW_PRODUCTS.PROD_SHOW_MORE_PRODUCTS" | translate }}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#003A70"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
            </button>
        </div>
    </div>
</div>
